<ng-container *ngIf="enableKlassIcon">
  <img class="klass-icon" alt="" src="/assets/images/{{ item.klass.toLowerCase() }}-{{ klassIconColor }}.png?v=1" />
</ng-container>

<div class="brand-name-icons">
  <ng-container *ngIf="showBrand">
    <span *ngIf="!!brandName; else loading" class="brand">
      <a *ngIf="enableBrandLink && !!brandLink" [routerLink]="brandLink">{{ brandName }}</a>

      <ng-container *ngIf="!enableBrandLink || !brandLink">
        <span [innerHTML]="brandName | highlight: highlightTerms"></span>
      </ng-container>
    </span>
  </ng-container>

  <span *ngIf="!!itemName; else loading" class="name">
    <ng-template #nameTemplate>
      <ng-container *ngIf="showBrand && !!brandName">&nbsp;</ng-container>
      <!-- Add space for copy/pasting -->
      <span [innerHTML]="itemName | highlight: highlightTerms"></span>
      <a
        *ngIf="showItemUnapprovedInfo && item.reviewerDecision !== EquipmentItemReviewerDecision.APPROVED"
        (click)="openItemUnapprovedInfoModal(item)"
        astrobinEventPreventDefault
        astrobinEventStopPropagation
        href="#"
      >
        <fa-icon icon="asterisk"></fa-icon>
      </a>

      <fa-icon
        *ngIf="showFrozenAsAmbiguous && item.frozenAsAmbiguous"
        [ngbTooltip]="'Frozen as ambiguous' | translate"
        icon="snowflake"
      ></fa-icon>

      <fa-icon
        *ngIf="item.followed"
        [ngbTooltip]="'You follow this equipment item' | translate"
        container="body"
        icon="bell"
      ></fa-icon>
    </ng-template>

    <ng-container *ngIf="enableNameLink; else noNameLinkTemplate">
      <a [routerLink]="nameLink">
        <ng-container [ngTemplateOutlet]="nameTemplate"></ng-container>
      </a>
    </ng-container>

    <ng-template #noNameLinkTemplate>
      <ng-container [ngTemplateOutlet]="nameTemplate"></ng-container>
    </ng-template>
  </span>

  <a
    *ngIf="
      showRetailers &&
      item.listings.allowFullRetailerIntegration &&
      (sellsListings.length || pairsWellListings.length || item.listings.brandListings.length)
    "
    (click)="openRetailersOffcanvas()"
    class="btn-retailers"
    astrobinEventPreventDefault
    astrobinEventStopPropagation
    href="#"
  >
    <fa-icon icon="shopping-cart"></fa-icon>
  </a>

  <button
    *ngIf="enableSummaryPopover"
    [ngbPopover]="itemSummaryPopoverTemplate"
    class="btn btn-link btn-info-modal btn-no-block"
    astrobinEventPreventDefault
    astrobinEventStopPropagation
    container="body"
    popoverClass="popover-equipment-item-summary"
    triggers="click"
  >
    <fa-icon icon="info-circle"></fa-icon>
  </button>
</div>

<ng-template #loading>
  <astrobin-text-loading-indicator></astrobin-text-loading-indicator>
</ng-template>

<ng-template #retailersTemplate let-offcanvas>
  <div class="offcanvas-header">
    <h4 class="offcanvas-title">{{ "Shop" | translate }}</h4>
    <button (click)="offcanvas.dismiss()" class="btn-close" aria-label="Close" type="button"></button>
  </div>
  <div class="offcanvas-body offcanvas-retailers">
    <!-- Sponsor message - always show if there are any affiliate listings -->
    <div *ngIf="sellsListings.length > 0 || item.listings.brandListings?.length > 0" class="alert alert-dark mb-4">
      <fa-icon icon="heart"></fa-icon>
      <span>{{ "Support AstroBin by shopping at one of our partners" | translate }}</span>
    </div>

    <!-- SELLS listings -->
    <ng-container *ngIf="sellsListings.length > 0">
      <div class="mb-4">
        <div *ngFor="let listing of sellsListings" class="retailer">
          <a [href]="listing.url" class="no-external-link-icon" target="_blank">
            <img *ngIf="listing.imageUrl" [src]="listing.imageUrl" alt="" />
            <img *ngIf="!listing.imageUrl && listing.retailer.logo" [src]="listing.retailer.logo" alt="" />
            <span *ngIf="!listing.imageUrl && !listing.retailer.logo">{{ listing.retailer.name }}</span>
          </a>
        </div>
      </div>
    </ng-container>

    <!-- PAIRS_WELL listings -->
    <ng-container *ngIf="pairsWellListings.length > 0">
      <div class="alert alert-dark mb-4">
        <fa-icon icon="link"></fa-icon>
        <span>{{ "Pair well with this" | translate }}</span>
      </div>

      <div class="mb-4">
        <div *ngFor="let listing of pairsWellListings" class="retailer">
          <a [href]="listing.url" class="no-external-link-icon" target="_blank">
            <img *ngIf="listing.imageUrl" [src]="listing.imageUrl" alt="" />
            <img *ngIf="!listing.imageUrl && listing.retailer.logo" [src]="listing.retailer.logo" alt="" />
            <span *ngIf="!listing.imageUrl && !listing.retailer.logo">{{ listing.retailer.name }}</span>
          </a>
        </div>
      </div>
    </ng-container>

    <!-- Brand listings -->
    <ng-container *ngIf="item.listings.brandListings?.length > 0 && !sellsListings.length && !pairsWellListings.length">
      <div>
        <div *ngFor="let listing of item.listings.brandListings" class="retailer">
          <a [href]="listing.url" class="no-external-link-icon" target="_blank">
            <img *ngIf="listing.retailer.logo" [src]="listing.retailer.logo" alt="" />
            <span *ngIf="!listing.retailer.logo">{{ listing.retailer.name }}</span>
          </a>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<ng-template #itemSummaryPopoverTemplate let-pop="ngbPopover">
  <div class="popover-header d-flex justify-content-between align-items-center gap-3">
    <span>{{ (item.brandName || ("DYI" | translate)) + " " + item.name }}</span>
    <button (click)="pop.close()" class="btn btn-link link-secondary" type="button">
      <span aria-hidden="true">
        <fa-icon class="m-0" icon="times"></fa-icon>
      </span>
    </button>
  </div>
  <div class="popover-content">
    <astrobin-equipment-item-summary
      [item]="item"
      [showClass]="false"
      [showEditButtons]="false"
      [showEmptyProperties]="false"
      [showImage]="false"
      [showMeta]="false"
      [showMostOftenUsedWith]="false"
      [showName]="false"
      [showProperties]="true"
      [showStats]="false"
      [showSubItem]="false"
      [striped]="false"
    ></astrobin-equipment-item-summary>
  </div>
</ng-template>
